/**
 * Formats a date object or valid date string based on locale and options
 * @param  {Date|string} date - Date object or date string to format
 * @param  {string} locale    - locale string
 * @param  {Object} [options] - optional object for formatting that will be
 *                              passed to Intl.DateTimeFormat()
 * @return {string}           - formatted date returned as a string
 */
export default function formatDate( date, locale, options ) {
    date = date instanceof Date ? date : new Date( date.toString().replace( /([+-]\d\d)(\d\d)$/, '$1:$2' ) );

    // If no options are passed, use these defaults
    options = options ? options : {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
    };

    return new Intl.DateTimeFormat( locale, options ).format( date );
}
